import { SoDataTableHeader } from "@/types/components/SoDataTable"
import { SoExportCsvButtonData } from "@/components/dataTable/SoExportCsvButton.vue"
import { IBulkSmartReadsResult } from "./meterpoint.types"
import { formatDateDashed } from "@/helpers/dateHelper"
import dayjs from "dayjs"

export const bulkSmartReadsResultHeader: SoDataTableHeader[] = [
  {
    title: "Meterpoint Id",
    key: "meterpointId",
  },
  {
    title: "MPXN",
    key: "mpxn",
  },
  {
    title: "Error",
    key: "error",
  },
]

interface IBulkSmartReadsResultExporter {
  getConfig: () => {
    data: SoExportCsvButtonData
    headers: SoDataTableHeader[]
    fileName: string
  }
}

export class BulkSmartReadsResultExporter implements IBulkSmartReadsResultExporter {
  private readonly exportData: IBulkSmartReadsResult[] | null

  constructor(exportData: IBulkSmartReadsResult[] | null) {
    this.exportData = exportData
  }

  public getConfig() {
    return {
      data: this.parseDataForCsv(),
      headers: bulkSmartReadsResultHeader,
      fileName: this.getFileName(),
    }
  }

  public parseDataForCsv(): SoExportCsvButtonData {
    if (!this.exportData?.length) {
      return { isLoading: false, items: [] }
    }

    const items = this.exportData?.map((result) => {
      const item: Record<string, string> = {}
      bulkSmartReadsResultHeader.forEach((header) => {
        const key = header.key as keyof IBulkSmartReadsResult
        item[key] = result[key] ?? ""
      })
      return item
    })

    return {
      isLoading: false,
      items,
    }
  }

  private getFileName(): string {
    return `bulk-xritm-result-${formatDateDashed(dayjs())}.csv`
  }
}
